import React from 'react';
import { Line, Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

// Underline "U" glyph for the message text-styles toolbar (not a Figma icon
// export; drawn to match the 24-viewBox stroke icons in this set).
export const UnderlineIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M6 4v6a6 6 0 0 0 12 0V4"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Line x1="4" y1="20" x2="20" y2="20" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </Svg>
);

UnderlineIcon.displayName = 'UnderlineIcon';
